import { motion, useScroll, useTransform } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import PraiseLogo from "@/components/PraiseLogo";

interface StickyFastPathProps {
  isLoggedIn: boolean;
}

export const StickyFastPath = ({ isLoggedIn }: StickyFastPathProps) => {
  const { scrollYProgress } = useScroll();
  
  const opacity = useTransform(scrollYProgress, [0.4, 0.5, 0.9, 1], [0, 1, 1, 0]);
  const y = useTransform(scrollYProgress, [0.4, 0.5], [20, 0]);

  return (
    <motion.div
      className="fixed bottom-0 left-0 right-0 z-50 pointer-events-none"
      style={{ opacity, y }}
    >
      <div className="max-w-4xl mx-auto px-4 pb-4">
        <div className="bg-background/95 backdrop-blur-sm border border-border rounded-full px-4 py-3 flex items-center justify-between gap-4 shadow-lg pointer-events-auto">
          <div className="flex items-center gap-2">
            <PraiseLogo size={20} />
            <p className="text-sm text-muted-foreground hidden sm:block">
              3 free extractions. No signup.
            </p>
          </div>
          <Link to={isLoggedIn ? "/agent" : "/auth"}>
            <Button size="sm" className="gradient-brand text-white rounded-full px-4 shadow-brand">
              Start Extracting
              <ArrowRight className="ml-1.5 h-3.5 w-3.5" />
            </Button>
          </Link>
        </div>
      </div>
    </motion.div>
  );
};
